import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import i18n from './modules/i18n'
import permission from './modules/permission'
import getters from './getters'
import { getCount } from '@/api/order/common'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    i18n,
    permission
  },
  state: {
    user_type: 1, // 1 锁安  2 锁协
    xiadanCount: '', // 客户下单数量
    cuidanCount: '', // 催单数量
    num: 0,
    backNum: 0
  },
  mutations: {
    getCuidanCount(state, count) {
      state.cuidanCount = count
    },
    getXiadanCount(state, count) {
      state.xiadanCount = count
    },
    getUserType(state, type) {
      state.user_type = type
    },
    changeBackNum(state, num) {
      state.backNum = num
    },
    changeAdd(state) {
      state.num++
    },
    changeAddN(state) {
      state.num--
    },
    changeNum(state, num) {
      state.num = num
    }
  },
  actions: {
    getXiadan({ commit }) {
      getCount().then(res => {
        console.log(9999999999, res)
        commit('getXiadanCount', res.data)
      })
    }
  },
  getters
})
